<template>
    <div class="bg-cover min-h-app flex items-center" :style="'background-image: url(' + $asset('/hkcm/images/auth.png', 'public') + ')'">
        <div class="container mx-auto my-16">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full">
                <div class="bg-white p-4 rounded-md shadow-md">
                    <h1>{{ $t('nav_contact') }}</h1>

                    <div class="my-2 mb-8" v-html="settings.company_address"></div>
                    <div class="my-2" v-html="settings.company_contact"></div>
                </div>
                <div class="bg-white p-4 rounded-md shadow-md">
                    <form @submit.prevent="send()" class="relative flex flex-col gap-2">
                        <Input type="text" name="name" :label="$t('plain_name')" v-model:value="contact.name" autocomplete="name"> </Input>
                        <Input type="text" name="email" :label="$t('email_adress')" v-model:value="contact.email" autocomplete="email"> </Input>
                        <TextArea name="message" :label="$t('Message')" v-model:value="contact.message" autocomplete="message"> </TextArea>

                        <FormButton type="submit" class="my-6" styling="primary flex items-center gap-3" :value="$t('contact_now')" :disabled="loading">
                            <FontAwesomeIcon
                                v-show="loading"
                                :icon="['fas', 'circle-notch']"
                                class="animate-spin text-white transition-all ease-in-out duration-300 w-0"
                                :class="loading ? 'w-10' : ''"
                            >
                            </FontAwesomeIcon>
                        </FormButton>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../api';

export default {
    data: () => ({
        contact: {},
        loading: false
    }),
    methods: {
        send() {
            this.loading = true;
            api.post('/api/v1/contact', this.contact)
                .then(() => {
                    this.loading = false;
                    this.contact = {};
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    },
    computed: {
        ...mapGetters('settings', {
            settings: 'get'
        })
    }
};
</script>
